module.exports = __webpack_public_path__ + "img/836233.92931c56.jpg";